import React from 'react';
import { Registry } from './Registry';
import layout from './Layout';

export function GetComp(name, modulename, attributes, api, fullurl) {
  const Api = { ...api, module: {}, log: {}, redirect: {}, getconf: {} };
  if (Registry[modulename].Entry) {
    // TODO reconsider adding Key=Current Date time, needs reasearch
    return React.createElement(Registry[modulename].Entry, { ...attributes, Api, key: new Date().getTime() });
  }
  const emptyDiv = null;

  if (Registry[modulename].ModuleRegistry) {
    Api.module = Registry[modulename].ModuleRegistry;

    if (Registry[modulename].ModuleRegistry.layout && Registry[modulename].ModuleRegistry.manifest) {
      const { manifest } = Registry[modulename].ModuleRegistry;
      let viewToRender = manifest.default_view;
      if (Object.prototype.hasOwnProperty.call(attributes, 'view_override') && attributes.view_override) {
        viewToRender = attributes.view_override;
      }
      if (fullurl.QString && Object.prototype.hasOwnProperty.call(fullurl.QString, name)) {
        viewToRender = fullurl.QString[name];
      }
      // TODO :  Check if the value matches a view, and if the view is routable or not
      const out = React.createElement(layout, {
        Api,
        View: viewToRender,
        InstanceName: name,
        ModuleName: modulename,
        Attributes: attributes,
      });
      return out;
    }
    return emptyDiv;
  }
}

export function RenderPage(page, api, fullurl) {
  let pageOut = null;

  // Ensure that module_type of 'Page' is passed in. We will NOT render any other module_type
  // in this method
  if (!page || !page.module_type || page.module_type !== 'Page') {
    return pageOut;
  }

  // Ensure that the user has the permission needed for the page. Required permissions
  // is configured in page.permission.
  // if (!api.security.hasPermission('page', 'action', null, page.permission, 'enabled')) {
  //   // TODO: show 403 error page. For now we will show empty page
  //   console.log(`User does not have ${page.permission} permission`);
  //   return pageOut;
  // }

  const { module_details: { layout: moduleLayout, assets: { regions } = {} } = {} } = page;

  if (moduleLayout && regions && Object.keys(regions).length > 0) {
    const layoutPayload = Object.entries(regions)
      .filter((region) => Array.isArray(region) && region.length > 0)
      .reduce((result, [key, region]) => {
        const container = region
          .filter(({ module_type: moduleType }) => moduleType === 'Component')
          .map(({ name, module_name: moduleName, module_details: moduleDetails }) =>
            GetComp(name, moduleName, moduleDetails, api, fullurl)
          );
        // eslint-disable-next-line no-param-reassign
        result[key] = container;
        return result;
      }, {});

    pageOut = GetComp(page.module_details.layout, page.module_details.layout, layoutPayload, api, fullurl);
  }
  return pageOut;
}

/* function log(message, severity = 'Error') {
  console.log(`${new Date().toISOString()} : ${severity}:${message}`);
} */
